import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>청소년 스마트폰 프리 운동본부</h3>
            <p>경기도 수원시 팔달구 효원로 303</p>
            <p>삼호파크타워 702호</p>
            <p>이메일: phonfreekr@gmail.com</p>
            <div style={{ marginTop: '1rem' }}>
              <a 
                href="https://www.youtube.com/@%EC%8A%A4%ED%94%84%EC%9A%B4%EB%8F%99%EB%B3%B8%EB%B6%80"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  background: '#ff0000',
                  color: 'white',
                  textDecoration: 'none',
                  fontSize: '0.9rem',
                  fontWeight: '500',
                  padding: '0.6rem 1.2rem',
                  border: '2px solid #ff0000',
                  borderRadius: '25px',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = '#ff0000';
                  e.currentTarget.style.borderColor = '#ff0000';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = '#ff0000';
                  e.currentTarget.style.color = 'white';
                  e.currentTarget.style.borderColor = '#ff0000';
                }}
              >
                📺 공식 유튜브 채널
              </a>
            </div>
          </div>
          <div className="footer-section">
            <h4>운동본부 소개</h4>
            <ul>
              <li><Link to="/greeting">인사말</Link></li>
              <li><Link to="/vision">설립취지 및 비전</Link></li>
              <li><Link to="/history">창립 경과보고</Link></li>
              <li><Link to="/organization">조직도</Link></li>
              <li><Link to="/office">사무국 안내</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>운동 및 활동</h4>
            <ul>
              <li><Link to="/smartphone-free">스마트폰프리운동</Link></li>
              <li><Link to="/activities">주요 활동</Link></li>
              <li><Link to="/notice">공지사항</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>언론 & 자료</h4>
            <ul>
              <li><Link to="/press-release">보도자료</Link></li>
              <li><Link to="/media-coverage">언론보도</Link></li>
              <li><Link to="/resources">자료실</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 청소년 스마트폰 프리 운동본부. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 